import React, { useState, useEffect } from 'react';
import {
  Collapse,
  makeStyles,
  List,
  ListItem,
  ListItemText,
  Divider,
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
    paddingLeft: '25px !important',
  },
  list: {
    transition: '175ms ease-in-out',
    color: '#b01e3f',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    padding: '4px 15px 4px 15px',
    fontSize: '16px',
    display: 'inline-block',
    '&:hover': {
      background: '#b01e3f',
      color: '#ffff',
    },
  },
  listSelected: {
    background: '#b01e3f',
    color: '#ffff',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    padding: '4px 15px 4px 15px',
    fontSize: '16px',
    display: 'inline-block',
    '&:hover': {
      background: '#b01e3f',
      color: '#ffff',
    },
  },
  nested: {
    display: 'inherit',
    margin: '1px 0px 10px 20px',
  },
  subList: {
    transition: '175ms ease-in-out',
    color: '#12498a',
    fontWeight: 700,
    textTransform: 'uppercase',
    paddingLeft: 10,
    paddingRight: 10,
    fontSize: '12px',
    display: 'inline-block',
    '&:hover': {
      background: '#12498a',
      color: '#ffff',
    },
  },
  selectedSubList: {
    transition: '175ms ease-in-out',
    background: '#12498a',
    color: '#ffff',
    fontWeight: 700,
    textTransform: 'uppercase',
    paddingLeft: 10,
    paddingRight: 10,
    fontSize: '12px',
    display: 'inline-block',
    '&:hover': {
      background: '#12498a',
      color: '#ffff',
    },
  },
  menuText: {
    fontFamily: '"Open Sans Condensed", sans-serif',
    fontWeight: 700,
  },
  subMenuText: {
    fontFamily: '"Open Sans Condensed", sans-serif',
    fontWeight: 700,
    paddingLeft: 10,
    paddingRight: 10,
  },
}));

function ListItemLink(props) {
  return (
    <ListItem
      button
      component='a'
      {...props}
    />
  );
}

const defaultMenus = [
  {
    name: 'Instructor Credential',
    link: 'https://www.ushja.org/education/instructor-credential',
    subMenu: [
      {
        name: 'APPLY',
        link: 'https://www.ushja.org/education/instructor-credential/apply',
      },
      {
        name: 'CALENDAR',
        link: 'https://www.ushja.org/education/instructor-credential/calendar',
      },
      {
        name: 'BENEFITS',
        link: 'https://www.ushja.org/education/instructor-credential/benefits',
      },
      {
        name: 'RESPONSIBILITIES',
        link: 'https://www.ushja.org/education/instructor-credential/responsibilities',
      },
      {
        name: 'INSTRUCTOR CREDENTIAL DIRECTORY',
        link: '/CredentialDirectory',
      },
      {
        name: 'RENEW',
        link: 'https://www.ushja.org/education/instructor-credential/renew',
      },
      {
        name: 'FAQ',
        link: 'https://www.ushja.org/education/instructor-credential/faq',
      },
      {
        name: 'RESOURCES',
        link: 'https://www.ushja.org/education/instructor-credential/resources',
      },
      {
        name: 'TRAINER CERTIFICATION',
        link: 'https://www.ushja.org/education/instructor-credential/trainer-certification',
      },
    ],
  },
  {
    name: 'Membership',
    link: 'https://www.ushja.org/competition/hunter/world-championship-hunter-rider-program/membership',
  },
  {
    name: 'Calendar',
    link: 'https://www.ushja.org/competition/hunter/world-championship-hunter-rider-program/calendar',
  },
  {
    name: 'Awards',
    link: 'https://www.ushja.org/competition/hunter/world-championship-hunter-rider-program/awards',
  },
  {
    name: 'Standings',
    link: 'https://www.ushja.org/competition/hunter/world-championship-hunter-rider-program/standings',
  },
  {
    name: 'Host/Management',
    link: 'https://www.ushja.org/competition/hunter/world-championship-hunter-rider-program/event-selection',
  },
  {
    name: 'Support WCHR',
    link: 'https://www.ushja.org/competition/hunter/world-championship-hunter-rider-program/donnar',
  },
];

const educationMenus = [
  {
    name: 'Directory of Clinics',
    link: 'https://www.ushja.org/education/resources/directory-clinics',
  },
  {
    name: 'Emerging Athletes Program',
    link: 'https://www.ushja.org/education/emerging-athletes-program',
  },
  {
    name: 'Educational Clinics',
    link: 'https://www.ushja.org/education/educational-forums',
  },
  {
    name: 'Gold Star Clinics',
    link: 'https://www.ushja.org/competition/jumper/emerging-jumper-rider-program/gold-star-clinic',
  },
  {
    name: 'Horsemanship Quiz Challenge',
    link: 'https://www.ushja.org/education/horsemanship-quiz-challenge',
  },
  {
    name: 'Licensed Officials Education',
    link: 'https://www.ushja.org/education/licensed-officials-education',
    subMenu: [
      {
        name: 'CALENDAR',
        link: '/education/licensed-officials-education/calendar',
      },
      {
        name: 'Resources',
        link: 'https://www.ushja.org/education/licensed-officials-education/resources',
      }],
  },
  {
    name: 'Recognized Riding Academy',
    link: 'https://www.ushja.org/education/recognized-riding-academy',
  },
  {
    name: 'Instructor Credential',
    link: 'https://www.ushja.org/education/instructor-credential',
    subMenu: [
      {
        name: 'APPLY',
        link: 'https://www.ushja.org/education/instructor-credential/apply',
      },
      {
        name: 'CALENDAR',
        link: 'https://www.ushja.org/education/instructor-credential/calendar',
      },
      {
        name: 'BENEFITS',
        link: 'https://www.ushja.org/education/instructor-credential/benefits',
      },
      {
        name: 'RESPONSIBILITIES',
        link: 'https://www.ushja.org/education/instructor-credential/responsibilities',
      },
      {
        name: 'INSTRUCTOR CREDENTIAL DIRECTORY',
        link: '/CredentialDirectory',
      },
      {
        name: 'RENEW',
        link: 'https://www.ushja.org/education/instructor-credential/renew',
      },
      {
        name: 'FAQ',
        link: 'https://www.ushja.org/education/instructor-credential/faq',
      },
      {
        name: 'RESOURCES',
        link: 'https://www.ushja.org/education/instructor-credential/resources',
      },
      {
        name: 'TRAINER CERTIFICATION',
        link: 'https://www.ushja.org/education/instructor-credential/trainer-certification',
      },
    ],
  },
  {
    name: 'Sport History/Museum',
    link: 'https://www.ushja.org/education/sport-historymuseum',
  },
  {
    name: 'Resources',
    link: 'https://www.ushja.org/education/resources/best-practices',
  },
];

const committeeMenus = [
  {
    name: 'Hunter/Jumper 101',
    link: 'https://www.ushja.org/about-us-and-news/hunterjumper-101',
  },
  {
    name: 'Our Mission/History',
    link: 'https://www.ushja.org/about-us-and-news/our-missionhistory',
  },
  {
    name: 'Contact Us',
    link: 'https://www.ushja.org/contact-us',
  },
  {
    name: 'Diversity and Inclusion Advocacy Resources',
    link: 'https://www.ushja.org/about-us-and-news/committees/diversity-inclusion-resources',
  },
  {
    name: 'Board/Committee',
    link: 'https://www.ushja.org/about-us-and-news/committees',
    subMenu: [
      {
        name: 'Minutes',
        link: 'https://www.dropbox.com/sh/6fu1cj3c7hiik26/AADjWLNvTgnh3AOIfpF91pcca?dl=0',
      },
    ],
  },
  {
    name: 'Bylaws and Policies',
    link: 'https://www.ushja.org/about-us-and-news/policy-manual',
  },
  {
    name: 'Annual Meeting',
    link: 'https://www.ushja.org/about-us-and-news/annual-meeting',
  },
  {
    name: 'Sponsors and Partners',
    link: 'https://www.ushja.org/about-us-and-news/sponsors-and-partners',
  },
  {
    name: 'Elections',
    link: 'https://www.ushja.org/about-us-and-news/elections',
  },
  {
    name: 'Town Halls',
    link: 'https://www.ushja.org/about-us-and-news/town-hall',
  },
  {
    name: 'Careers',
    link: 'https://www.ushja.org/about-us-and-news/careers',
  },
  {
    name: 'USHJA Staff Values',
    link: 'https://www.ushja.org/about-us-and-news/staff-values',
  },
  {
    name: 'Strategic Plan',
    link: 'https://www.ushja.org/about-us-and-news/strategic-plan',
  },
  {
    name: 'Financials',
    link: 'https://www.ushja.org/about-us-and-news/tax-statement',
  },
];

const programCalendarMenus = [
  {
    name: '2023 PLATINUM PERFORMANCE/USHJA HUNTER CHAMPIONSHIP WEEK',
    link: 'https://www.ushja.org/competition/hunter-week-championships',
  },
  {
    name: 'COMPETITION MANAGEMENT RESOURCES/SPECIFICATIONS',
    link: 'https://www.ushja.org/competition/host-and-competition-management',
  },
  {
    name: 'HUNTER',
    link: 'https://www.ushja.org/competition/hunter',
  },
  {
    name: 'JUMPER',
    link: 'https://www.ushja.org/competition/jumper',
  },
  {
    name: 'EQUITATION',
    link: 'https://www.ushja.org/competition/equitation',
  },
  {
    name: 'NATIONAL CHAMPIONSHIP',
    link: 'https://www.ushja.org/competition/national-championship',
  },
  {
    name: 'OUTREACH',
    link: 'https://www.ushja.org/competition/outreach',
  },
  {
    name: 'RULES AND PROPOSALS',
    link: 'https://www.ushja.org/competition/rules-and-proposals/overview',
  },
]

export default function SimpleList() {
  const classes = useStyles();
  const [openIcMenu, setOpenIcMenu] = useState(false);
  const location = window?.location?.pathname || '';
  const [isEducationRoute, setIsEducationRoute] = useState(false);
  const [sMenu, setSMenu] = useState(defaultMenus);
  const educationEndPoints = ['credentialDirectory', 'CredentialDirectory', 'education'];
  
  useEffect(() => {
    let pathName = window?.location?.pathname || '';
    if (typeof pathName === 'string' && pathName.includes('/')) {
      pathName = pathName.split('/')[1];
      if (pathName === 'credentialDirectory' || pathName === 'CredentialDirectory') {
        setOpenIcMenu(true);
      }
      if (educationEndPoints.indexOf(pathName)!==-1) {
        setSMenu(educationMenus);
        setIsEducationRoute(true);
      }
      if(pathName === 'committee'){
        setOpenIcMenu(true);
        setSMenu(committeeMenus);
      }
      if(pathName === 'calendar'){
        setSMenu(programCalendarMenus);
      }
    }
  }, [location]);

  const selectedMenu = (path, subMenu, subMenuList) => {
    let pathName = window?.location?.pathname || '';
    if (path && typeof pathName === 'string' && pathName.includes('/')) {
      if (pathName === path) {
        return subMenu ? classes.selectedSubList : classes.listSelected;
      }
      if (!subMenu && subMenuList && subMenuList?.length) {
        for (let i = 0; i < subMenuList.length; i++) {
          if (pathName.includes(subMenuList[i].link)) {
            return classes.listSelected;
          }
        }
      }
    }
    return subMenu ? classes.subList : classes.list;
  };

  const subMenuSelected = (path, subMenu, subMenuList) => {
    let pathName = window?.location?.pathname || '';
    if (path && typeof pathName === 'string' && pathName.includes('/')) {
      if (pathName === path) {
        return subMenu ? classes.selectedSubList : classes.listSelected;
      }
      if (!subMenu && subMenuList && subMenuList?.length) {
        for (let i = 0; i < subMenuList.length; i++) {
          if (pathName.includes(subMenuList[i].link)) {
            return true;
          }
        }
      }
    }
    return false;
  };

  return (
    <div className={classes.root}>
      <List component='nav'>
        {sMenu.map((menu) => {
          const openSubMenu = subMenuSelected(menu.link, false, menu.subMenu);
          return menu?.subMenu?.length ? (
            <>
              <ListItemLink
                className={selectedMenu(menu.link, false, menu.subMenu)}
                href={menu.link}
              >
                <ListItemText
                  classes={{
                    primary: classes.menuText,
                  }}
                  primary={menu.name}
                />
              </ListItemLink>
              {!openIcMenu && !openSubMenu && (
                <Divider style={{ height: 3, background: '#a09f9f' }} />
              )}
              <Collapse
                in={openIcMenu || openSubMenu}
                timeout='auto'
                unmountOnExit
              >
                <List
                  component='div'
                  disablePadding
                  className={classes.nested}
                >
                  {menu.subMenu.map((sMenu) => (
                    <ListItemLink
                      className={selectedMenu(sMenu.link, true)}
                      href={sMenu.link}
                      style={{
                        padding: 0,
                      }}
                    >
                      <ListItemText
                        classes={{
                          primary: classes.subMenuText,
                        }}
                        primary={sMenu.name}
                      />
                    </ListItemLink>
                  ))}
                </List>
              </Collapse>
              {openIcMenu && (
                <Divider
                  style={{ height: 2, background: '#a09f9f', display: 'block' }}
                />
              )}
            </>
          ) : (
            <>
              <ListItemLink
                className={classes.list}
                href={menu.link}
              >
                <ListItemText
                  classes={{
                    primary: classes.menuText,
                  }}
                  primary={menu.name}
                />
              </ListItemLink>
              <Divider style={{ height: 3, background: '#a09f9f' }} />
            </>
          );
        })}
      </List>
    </div>
  );
}
